import a from "./index925.js";
import e from "./index809.js";
function f(r, n) {
  return a(r, n, function(i, t) {
    return e(r, t);
  });
}
export {
  f as default
};
